export default "__VITE_ASSET__609d7085__"